import { useState } from "react"
import { kinship } from "../../../data/kinship"
import { Input } from "../../../components/ui/Input"
import SearchableSelect from "../../../components/ui/SearchableSelect"
import { Button } from "../../../components/ui/Button"
import { FaPlus, FaTrash } from "react-icons/fa"
import { maskCpf } from "../../../util/mask"
import { isValidCPF } from "../../../model/enum"
import { Alert } from "../../../util/Alert"

export default function BeneficiaryForm({ insuranceBeneficiaries, setInsuranceBeneficiaries }) {
    const [cpf, setCpf] = useState("")
    const [nome, setNome] = useState("")
    const [dataNascimento, setDataNascimento] = useState("")
    const [selectedKinship, setSelectedKinship] = useState(null)

    const handleAddBeneficiary = () => {
        if (!isValidCPF(cpf)) {
            Alert('Cpf Do Beneficiário Do Seguro Inválido', '', false, true, false);
            return;
        }
        if (!nome) {
            Alert('Nome Do Beneficiário Do Seguro Inválido', '', false, true, false);
            return;
        }
        if (!dataNascimento) {
            Alert('Data De Nascimento Do Beneficiário Do Seguro Inválido', '', false, true, false);
            return;
        }
        if (!selectedKinship) {
            Alert('Selecione o Grau De Paretesco Do Beneficiário Do Seguro', '', false, true, false);
            return;
        }
        if (insuranceBeneficiaries.map(x => x.cpfBeneficiario).includes(cpf)) {
            Alert('Cpf Já Adicionado', '', false, true, false);
            return;
        }

        // Novo beneficiário
        const newBeneficiary = {
            cpfBeneficiario: cpf,
            dataNascimentoBeneficiario: `${dataNascimento}T00:00:00`,
            grauParentesco: selectedKinship.value,
            idBeneficiario: 0,
            nomeBeneficiario: nome.toUpperCase(),
            percentualParticipacao: 0 // será recalculado
        }

        // Atualiza lista
        const updatedList = [...insuranceBeneficiaries, newBeneficiary]

        // Calcula percentual
        const percentual = +(100 / updatedList.length).toFixed(2)
        const finalList = updatedList.map(b => ({
            ...b,
            percentualParticipacao: percentual
        }))

        setInsuranceBeneficiaries(finalList)

        // limpa campos
        setCpf("")
        setNome("")
        setDataNascimento("")
        setSelectedKinship(null)
    }

    const handleRemoveBeneficiary = (index) => {
        // remove pelo índice
        const updatedList = insuranceBeneficiaries.filter((_, i) => i !== index)

        // recalcula percentual
        if (updatedList.length > 0) {
            const percentual = +(100 / updatedList.length).toFixed(2)
            const finalList = updatedList.map(b => ({
                ...b,
                percentualParticipacao: percentual
            }))
            setInsuranceBeneficiaries(finalList)
        } else {
            // se não sobrar ninguém, limpa a lista
            setInsuranceBeneficiaries([])
        }
    }


    return (
        <div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-5 mb-5">
                <Input
                    label="Cpf"
                    placeholder="xxx.xxx.xxx-xx"
                    value={maskCpf(cpf)}
                    maxLength={14}
                    onChange={e => setCpf(e.target.value)}
                />
                <Input
                    label="Nome Beneficiário"
                    placeholder="Nome Beneficiário"
                    value={nome}
                    onChange={e => setNome(e.target.value)}
                />
                <Input
                    label="Data De Nascimento"
                    type="date"
                    value={dataNascimento}
                    onChange={e => setDataNascimento(e.target.value)}
                />
                <SearchableSelect
                    label="Grau De Parentesco"
                    options={kinship}
                    onChange={value => setSelectedKinship(value)}
                    value={selectedKinship}
                    className="w-full"
                />
                <div className="col-span-2 md:col-span-1 flex items-center justify-center">
                    <button onClick={handleAddBeneficiary} className="flex items-center justify-center w-full mt-5 bg-[#FA6300] hover:bg-[#eee6fb] text-white text-sm font-medium rounded-lg px-5 py-3 transition-colors duration-300">
                        <FaPlus /> Adicionar
                    </button>
                </div>
            </div>
            <div className="mt-5 mb-5">
                <h2 className="font-bold">Beneficiários:</h2>
                <ul className="list-disc pl-5">
                    {insuranceBeneficiaries.map((b, i) => (
                        <li key={i} className="flex items-center gap-5">
                            <button onClick={() => handleRemoveBeneficiary(i)}><FaTrash className="text-red-500" /></button>
                            {b.nomeBeneficiario} - {b.cpfBeneficiario} -{" "}
                            {b.percentualParticipacao}%
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}